import { gql } from '@apollo/client';

export const ENGINE_ATTRIBUTE_DELETE = gql`
  mutation engineAttributeDelete($engineAttributeId: Int!) {
    engineAttributeDelete(engineAttributeId: $engineAttributeId) {
      commandId
      correlationId
    }
  }
`;

export const EXPORT_ENGINE_ATTRIBUTES = gql`
  mutation exportEngineAttributes($input: EngineAttributeFilterMutationExportInput) {
    exportEngineAttributes(input: $input) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;

export const ENGINE_ATTRIBUTE_SAVE = gql`
  mutation engineAttribute($input: EngineAttributeSave) {
    engineAttribute(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const TEST_ENGINE_ATTRIBUTE = gql`
  mutation testEngineAttribute($input: TestEngineAttribute) {
    testEngineAttribute(input: $input) {
      commandId
      correlationId
    }
  }
`;
